/* index.js */

"use strict";
const SolutionRegisterer = require("./src/solutionRegistrations");
const RegistrationNamespaces = require("./src/RegistrationNamespaces");
const SolutionsDefs = require("./src/Solutions");

require("./src/icons/branding/registericons");
require("./src/icons/solutions/registericons");

// below array determines the order of nav -- Order from soln def deprecated
const SOLUTIONS_LIST = [
    "Dashboard",
    "DeviceManager",
    "ConfigDrift",
    "OsManager",
    "ModelEditor",
    "WorkflowExplorer",
    "FileServer",
    "DataExplorer",
    "DataExport",
    "WorkTrig",
    "PackageManagement",
    "Settings",
    "VersionControl",
    "Rpa",
    "Topology",
];
class Solutions {
    constructor() {}
    static registerSolutions(Steve, isDi = false) {
        // Register the solutions
        if (!Steve) {
            console.error("Invalid arguments");
            return;
        }
        if (!Steve.di && !isDi) {
            console.error("Steve.di required to register solutions");
            return;
        }
        const registeredSolns = new SolutionRegisterer(isDi ? Steve : Steve.di);
        return registeredSolns;
    }

    static getRegistrations() {
        return RegistrationNamespaces;
    }

    static getAllSolutionsDefinitions() {
        return SolutionsDefs;
    }

    /*
        Expected solName inputs
        --------------------------
        ModelEditor
        WorkflowExplorer
        ConfigDrift
        DataExport
        OsManager
        Dashboard
        DeviceManager
        FileServer
        WorkTrig
        Settings
        PackageManagement
        DataExplorer
        Rpa
    */

    static getSolutionsDefinition(solName) {
        return SolutionsDefs[solName];
    }

    /*
    nav data structure
    {
    id: string; // gave the names from current definitions
    path: string;
    label: string;
    title: string;
    licenses: string[];
    disabled: boolean; // For now same as the boolean we have which can be used to disable solutions from def
    // Computed properties
    hasLicenses: boolean; // For licenses
    hasAccess: boolean; // For access permission check
    // Optional properties
    helpUrl?: string; // Moved to optional as not all might have this
    accessPermissions? : []; // Children might not need this
    icon?: string; // Currently the name we use in game center, anther prop can be added based on icomoon
    children?: IRoute[];
}

    */

    static getNavData() {
        return SOLUTIONS_LIST.map((soln) => {
            return this.generateSolnNavObject(soln);
        });
    }

    // Build URL utility method
    static getUrl(solName, options) {
        const solDef = this.getSolutionsDefinition(solName);
        const {app, section} = solDef.def;
        let slnName = solDef.namespace.split(".");
        slnName = slnName[slnName.length - 1];
        return this.generatePath({app, section, slnName}, options);
    }

    static generateSolnNavObject(solName) {
        const solDef = this.getSolutionsDefinition(solName);
        const {app, section} = solDef.def;
        let slnName = solDef.namespace.split(".");
        slnName = slnName[slnName.length - 1];

        const obj = {
            id: solDef.def.name,
            label: solDef.def.label,
            title: solDef.def.title || solDef.def.label,
            licenses: solDef.def.license,
            accessPermissions: solDef.def.accessPerm,
            disabled: solDef.def.disabled,
            icon: solDef.def.navIcon,
            helpUrl: solDef.def.helpLink
                ? "/#!/_app_/GameConsole/_s_/RoboHelp/_sln_/" + solDef.def.helpLink
                : "",
        };

        obj.path = this.generatePath({app, section, slnName});

        if (solDef.def.navOptions) {
            obj.children = Object.entries(solDef.def.navOptions).map((navOpt) => {
                let path = "";
                if (navOpt[1].steve2Path) {
                    path = navOpt[1].steve2Path;
                } else {
                    path = this.generatePath({app, section, slnName}, navOpt[1].options);
                }

                const child = {
                    id: slnName + navOpt[0],
                    label: navOpt[1].name,
                    title: solDef.def.title || solDef.def.label,
                    path,
                    perms: navOpt[1].perms || [],
                };
                if (navOpt[1].helpLink) {
                    child.helpUrl = navOpt[1].helpLink;
                }
                return child;
            });
        }
        return obj;
    }

    static generatePath({app, section, slnName}, options) {
        let path = "";
        if (slnName.toLowerCase() !== "classic") {
            // https://fe-london.gluware.com/#!/_app_/GameConsole/_s_/GameCenter/_rd_/JTdCJTdE/_sln_/DataExplorer
            if (slnName.toLowerCase() === "dashboard") {
                path = `/#!/_app_/${app}/_s_/${section}`;
            } else if (slnName.toLowerCase() === "rpa") {
                path = `/frontend/rpa`;
            } else if (slnName.toLowerCase() === "topology") {
                path = `/frontend/topology`;
            } else if (
                slnName.toLowerCase() === "settings" &&
                options &&
                options.sr === "User/EditMyProfile"
            ) {
                path = `/frontend/settings/users/edit-my-profile`;
                // New Edit My Profile page doesn't need any option extensions to be added to URL
                return path;
            } else {
                path = `/#!/_app_/${app}/_s_/${section}/_sln_/${slnName}`;
            }
        } else {
            // https://fe-london.gluware.com/_app_/gluware_control/#!/s/Perspective/rd/JTdCJTdE
            path = `/_app_/gluware_control/#!/s/Perspective`;
        }
        if (options && typeof options === "object") {
            path = Object.keys(options).reduce((path, opt) => {
                if (slnName.toLowerCase() === "rpa" || slnName.toLowerCase() === "topology") {
                    return (path += `/${options[opt]}`);
                }
                if (opt !== "rd") {
                    return (path += `/_${opt}_/${options[opt]}`);
                }
                if (slnName.toLowerCase() !== "classic") {
                    return (path += `/_rd_/${this._b64EncodeUnicode(
                        JSON.stringify(options[opt])
                    )}`);
                }
                return (path += `/rd/${this._b64EncodeUnicode(JSON.stringify(options[opt]))}`);
            }, path);
        }
        return path;
    }

    static _b64EncodeUnicode(str) {
        let encodedUri = encodeURIComponent(str);
        let b64 = btoa(encodedUri);
        return b64;
    }

    static matchLicenses(availableLicenses, routes) {
        if (!availableLicenses || !Array.isArray(availableLicenses)) {
            return routes.map((route) => {
                route.hasLicenses = false;
                return route;
            });
        }

        return routes.map((route) => {
            route.hasLicenses = this._match(availableLicenses, route.licenses);
            return route;
        });
    }

    static matchPermissions(availablePerm, routes) {
        if (!availablePerm || !Array.isArray(availablePerm)) {
            return routes.map((route) => {
                route.hasAccess = false;
                return route;
            });
        }

        return routes.map((route) => {
            route.hasAccess = this._match(availablePerm, route.accessPermissions);
            return route;
        });
    }

    static _match(list = [], values = []) {
        let matched = true;
        values.forEach((val) => {
            if (matched && list.indexOf(val) >= 0) {
                matched = true;
            } else {
                matched = false;
            }
        });
        return matched;
    }
}

module.exports = Solutions;
